import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Box } from "@mui/material";

const localizer = momentLocalizer(moment);

const AttendanceCalendar = () => {
  // Sample events (tasks, shifts, breaks)
 const [events] = useState([
  {
    id: 1,
    title: "Task #1",
    start: new Date(2025, 8, 1, 9, 15),  // Sept 1, 2025 at 9:15 AM
    end: new Date(2025, 8, 1, 11, 15),   // Sept 1, 2025 at 11:15 AM
    status: "Present",
    worker: "Jeneliya Doe",
    clockIn: "9:15",
    clockOut: "6:12",
    break: "1:18 - 2:24",
  },
  {
    id: 2,
    title: "Task #2",
    start: new Date(2025, 8, 2, 13, 0),  // Sept 2, 2025 at 1:00 PM
    end: new Date(2025, 8, 2, 15, 0),    // Sept 2, 2025 at 3:00 PM
    status: "Absent",
    worker: "John Smith",
    clockIn: "-",
    clockOut: "-",
    break: "-",
  },
  {
    id: 3,
    title: "Task #3",
    start: new Date(2025, 8, 3, 10, 0),  // Sept 3, 2025 at 10:00 AM
    end: new Date(2025, 8, 3, 14, 0),    // Sept 3, 2025 at 2:00 PM
    status: "Leave",
    worker: "Sarah Johnson",
    clockIn: "-",
    clockOut: "-",
    break: "-",
  },
  {
    id: 4,
    title: "Task #4",
    start: new Date(2025, 8, 4, 8, 30),  // Sept 4, 2025 at 8:30 AM
    end: new Date(2025, 8, 4, 17, 0),    // Sept 4, 2025 at 5:00 PM
    status: "Present",
    worker: "Mike Wilson",
    clockIn: "8:30",
    clockOut: "5:00",
    break: "1:00 - 2:00",
  },
  {
    id: 5,
    title: "Task #5",
    start: new Date(2025, 8, 6, 14, 0),  // Sept 6, 2025 at 2:00 PM
    end: new Date(2025, 8, 6, 18, 0),    // Sept 6, 2025 at 6:00 PM
    status: "Half Leave",
    worker: "Emma Davis",
    clockIn: "2:00",
    clockOut: "6:00",
    break: "—",
  },
]);

  // Custom styling per event
  const eventStyleGetter = (event) => {
    let backgroundColor = "#3174ad"; // default blue
    if (event.status === "Present") backgroundColor = "#00C48C";
    if (event.status === "Absent") backgroundColor = "#FF647C";
    if (event.status === "Leave") backgroundColor = "#006EC2";
    if (event.status === "Early Out") backgroundColor = "#9F4BFF";
    if (event.status === "Half Leave") backgroundColor = "#FDD35C";

    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "6px",
        border: "0px",
        display: "block",
        paddingLeft: "4px",
      },
    };
  };

  // Custom tooltip (like your screenshot popup)
  const EventTooltip = ({ event }) => (
    <Box sx={{ p: 1, fontSize: "13px", fontFamily: "Poppins" }}>
      <strong>Worker:</strong> {event.worker} <br />
      <strong>Clock In:</strong> {event.clockIn} <br />
      <strong>Clock Out:</strong> {event.clockOut} <br />
      <strong>Break:</strong> {event.break} <br />
      <strong>Status:</strong>{" "}
      <span style={{ color: eventStyleGetter(event).style.backgroundColor }}>
        {event.status}
      </span>
    </Box>
  );

  return (
    <Box sx={{ height: "80vh", p: 2, background: "#fff", borderRadius: "8px" }}>
      <Calendar
        localizer={localizer}
        events={events}
        defaultView="week"
        views={["day", "week", "month"]}
        startAccessor="start"
        endAccessor="end"
        style={{ height: "100%" }}
        eventPropGetter={eventStyleGetter}
        tooltipAccessor={null} // disable default tooltip
        components={{
          event: ({ event }) => (
            <span>{event.title}</span> // compact block inside calendar
          ),
        }}
      />
    </Box>
  );
};

export default AttendanceCalendar;
